export default __webpack_public_path__ + "static/mobile-app-d1997a0603600b64724424b2abb5bfc8.png";